import {IOverlay} from '@chancer/common/lib/interfaces/overlay/OverlayInterfaces';
import {ActionType, IAction} from '../Actions';

export function addOverlay(overlay: IOverlay): IAction<IOverlay> {
  return {
    payload: overlay,
    type: ActionType.SEND_OVERLAY_ADD,
  };
}
